import React from 'react';
import { Card } from '../ui';
import { PageHeader } from '../components/PageHeader';
import { AICaseIntelligencePage } from './AICaseIntelligencePage';
import { useBookings } from '../context/BookingContext';

export const CaseFilesPage = ({ onNavigate, navState }) => {
  const { bookings, loading } = useBookings();

  const caseCards = (Array.isArray(bookings) ? bookings : [])
    .filter(b => !navState?.filter || (navState.filter === 'active' ? b.status === 'accepted' : b.status === navState.filter))
    .map((b) => ({
    id:             b.caseId || b._id || b.id || "",
    bookingId:      b.caseId || b._id || b.id || "",   // explicit for AICaseIntelligencePage
    caseId:         b.caseId || b._id || b.id || "",
    name:           b.clientName || b.client_name || "Client",
    clientName:     b.clientName || b.client_name || "Client",
    type:           b.caseType   || b.case_type   || "General Legal",
    caseType:       b.caseType   || b.case_type   || "General Legal",
    stage:          b.status     || "pending",
    status:         b.status     || "pending",
    next:           b.date       || "—",
    priority:       b.urgency    || "flexible",
    docs:           Number(b.docs         ?? 0),
    docsCompleted:  Number(b.docsCompleted ?? 0),
    tasks:          Number(b.tasks         ?? 0),
    tasksCompleted: Number(b.tasksCompleted ?? 0),
    location:       b.location    || "",
    summary:        b.description || b.summary || "",
  }));

  if (navState?.caseData) {
    return <AICaseIntelligencePage onNavigate={onNavigate} navState={navState} />;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20 text-slate-400 text-sm">
        Loading cases...
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title="Cases"
        subtitle="Manage your active and closed cases"
        showBack={false}
        rightAction={
          <button
            onClick={() => onNavigate('bookings')}
            className="px-5 py-2.5 rounded-xl bg-[#071b33] text-white font-semibold"
          >
            + New Case
          </button>
        }
      />

      <div className="space-y-4">
        {!loading && caseCards.length === 0 && (
          <div className="text-center py-16 text-slate-400 text-sm">
            No cases found. Book a consultation to get started.
          </div>
        )}

        {caseCards.map((item) => (
          <Card key={item.id} className="p-0">
            <div className="p-6">
              <div className="flex flex-wrap items-center gap-3 mb-3">
                <h3 className="text-3xl font-bold">{item.name}</h3>
                <span className="px-3 py-1 rounded-lg bg-slate-100 text-slate-500 text-sm">{item.id}</span>
                <span className="px-3 py-1 rounded-full bg-amber-50 text-amber-700 text-sm">{item.priority}</span>
              </div>
              <p className="text-slate-600 mb-4">{item.type} · Stage: <span className="font-semibold">{item.stage}</span> · Next: {item.next}</p>

              <div className="mb-4">
                <div className="h-2 rounded-full bg-slate-100 relative">
                  <div
                    className="absolute left-0 top-0 h-2 rounded-full bg-blue-500"
                    style={{
                      width:
                        item.stage === 'accepted'  ? '50%'  :
                        item.stage === 'pending'   ? '20%'  :
                        item.stage === 'completed' ? '100%' :
                        item.stage === 'rejected'  ? '0%'   : '10%'
                    }}
                  />
                </div>
              </div>

              <div className="flex flex-wrap gap-2">
                <button className="px-5 py-2.5 rounded-xl border border-blue-300 bg-blue-50 text-blue-700 font-medium">
                  {item.docsCompleted}/{item.docs} Documents
                </button>
                <button className="px-5 py-2.5 rounded-xl border border-blue-300 bg-blue-50 text-blue-700 font-medium">
                  {item.tasksCompleted}/{item.tasks} Task
                </button>
                <button
                  onClick={() => onNavigate('cases', { caseData: item })}
                  className="px-5 py-2.5 rounded-xl border border-emerald-500 text-emerald-700 font-semibold hover:bg-emerald-500 hover:text-white transition-colors"
                >
                  View Case Powered by AI
                </button>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};
